import React from 'react';
import { PARAMS } from "../../../../config";

const Head = ({ onSortChange }) => {
    const th = PARAMS.map(([ param, title ]) => <th onClick={() => onSortChange(param)} key={param}>{title}</th>);

    return (
        <thead>
            <tr>
                {th}
            </tr>
        </thead>
    )
};

export default Head;


// WEBPACK FOOTER //
// ./src/scenes/AdKernel/components/Table/components/Head/index.js